// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-iframe {\n  position: fixed;\n  top: calc(58px + 40px);\n  left: 0;\n  z-index: 99;\n  width: 100%;\n  height: calc(100vh - 58px - 40px);\n  background: #f5f7f9;\n}\n.index-iframe .inner-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n.index-iframe-tenant {\n  height: 100%;\n  background: #f5f7f9;\n}\n.index-iframe-tenant .inner-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
